import type { IconData } from '@stacksjs/iconify-core'

export const interfaceEssentialExpand1: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M32 0h-9.15v1.52h6.1v1.53h1.52v6.09H32z\"/><path fill=\"currentColor\" d=\"M27.42 3.05h1.53v1.52h-1.53ZM25.9 4.57h1.52v1.52H25.9Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53h-1.52Zm-1.53 1.53h1.53v1.52H19.8Zm-1.52 1.52h1.52v1.52h-1.52Zm-6.09 6.1h1.52v1.52h-1.52Zm-1.53 1.52h1.53v1.52h-1.53Zm-1.52 1.52h1.52v1.53H9.14Zm-1.53 1.53h1.53v1.52H7.61Zm-1.52 1.52h1.52v1.52H6.09ZM4.57 25.9h1.52v1.53H4.57Zm-1.53 1.53h1.53v1.52H3.04Z\"/><path fill=\"currentColor\" d=\"M9.14 30.48h-6.1v-1.53H1.52v-6.09H0V32h9.14z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default interfaceEssentialExpand1
